import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function ConfirmForgotPassword() {
    const { t } = useTranslation();

    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [passwordMismatchError, setPasswordMismatchError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setPasswordMismatchError('');

        if (newPassword !== confirmNewPassword) {
            setPasswordMismatchError(t('confirmForgotPassword.passwordMismatch'));
            return;
        }

        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}auth/confirm_forgot_password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email, code, newPassword, confirmNewPassword }),
            });

            const data = await res.json();

            if (res.ok) {
                setMessage(t('confirmForgotPassword.successMessage'));
            } else {
                throw new Error(data.message || 'Unknown error');
            }
        } catch (err) {
            setError(t('confirmForgotPassword.errorMessagePrefix') + err.message);
        }
    };

    return (
        <div className="login-container">
            <img src="/images/main_logo_horizontal_cinza.svg" alt="logo" style={{ marginBottom: '1.5rem' }} />
            <form onSubmit={handleSubmit} className="login-form">
                <h2 style={{ textAlign: 'center' }}>{t('confirmForgotPassword.title')}</h2>

                <input
                    type="email"
                    placeholder={t('confirmForgotPassword.emailPlaceholder')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />

                <input
                    type="text"
                    placeholder={t('confirmForgotPassword.codePlaceholder')}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    required
                />

                <input
                    type="password"
                    placeholder={t('confirmForgotPassword.newPasswordPlaceholder')}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                />

                <input
                    type="password"
                    placeholder={t('confirmForgotPassword.confirmNewPasswordPlaceholder')}
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    required
                />

                {passwordMismatchError && (
                    <p style={{ color: 'red', marginTop: '0.5rem' }}>{passwordMismatchError}</p>
                )}

                <button
                    type="submit"
                    disabled={!email || !code || !newPassword || !confirmNewPassword}
                >
                    {t('confirmForgotPassword.submitButton')}
                </button>

                {message && <p style={{ color: 'green', marginTop: '1rem' }}>{message}</p>}
                {error && <p style={{ color: 'red', marginTop: '1rem' }}>{error}</p>}
            </form>
        </div>
    );
}

export default ConfirmForgotPassword;
